import React, {
  CSSProperties,
  FC, useEffect, useRef, useState,
} from 'react';
import { greenCheck } from '../../../../../../../assets/base64Images/ai/greenCheck';
import { aiCheckLoading } from '../../../../../../../assets/base64Images/ai/aiCheckLoading';
import { ColumnCenter, RobotContent } from './Styles';
import TempFieldUtils from '../../../../../../../lib/TempFieldUtils';
import { RowLeft, Row } from '../../../Styles';
import { lang } from '../../../../../../../lib/utils/utils';

const CheckLoading: FC<Props> = ({
  flowId,
  zhText,
  enText,
  style,
}) => {
  const [ShowLoading, setShowLoading] = useState<boolean>(true);
  // 是不是保留的loading
  const [isRetain, setIsRetain] = useState<boolean>(false);
  const loadingRef = useRef<any>();
  const enRef = useRef<any>();
  const zhRef = useRef<any>();

  useEffect(() => {
    const interval = setInterval(() => {
      if (enRef.current && zhRef.current) {
        const langValue = lang(enText, zhText);
        if (langValue === enText) {
          enRef.current.style.display = 'block';
          zhRef.current.style.display = 'none';
        }
        else {
          enRef.current.style.display = 'none';
          zhRef.current.style.display = 'block';
        }
      }
    }, 100);

    return () => clearInterval(interval);
  }, [zhText, enText]);

  useEffect(() => {
    if (loadingRef.current) {
      let opacity = 1;
      const interval = setInterval(() => {
        if (loadingRef.current && flowId && TempFieldUtils.aiFlowIds.includes(flowId)) {
          opacity -= 0.05;
          if (opacity < 0) {
            opacity = 0;
          }
          loadingRef.current.style.opacity = `${opacity}`;
          if (opacity <= 0) {
            setShowLoading(false);
            clearInterval(interval);
          }
        }
      }, 10);

      // 组件卸载时清除定时器
      return () => clearInterval(interval);
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      checkNeedHideLoading();
    }, 100);
  }, []);

  const checkNeedHideLoading = () => {
    if (flowId) {
      if (TempFieldUtils.aiRetainLoadingIds.includes(flowId)) {
        setIsRetain(true);
      }
      else {
        setTimeout(() => {
          checkNeedHideLoading();
        }, 100);
      }
    }
  };

  if (!ShowLoading) {
    return <></>;
  }

  return (
    <RowLeft ref={loadingRef}>
      {
        !isRetain && (
          <ColumnCenter>
            <img src={aiCheckLoading} style={{ width: 23, height: 23 }} />
          </ColumnCenter>
        )
      }
      <ColumnCenter style={{ alignItems: 'flex-start', paddingLeft: !isRetain ? 15 : 0 }}>
        <Row>
          <RobotContent style={{ fontFamily: lang('Squad-Regular, Squad', 'PingFangSC-Regular, PingFang SC'), ...style }}>
            <div style={{ display: 'none', fontFamily: 'Squad-Regular, Squad' }} ref={enRef}>
              {enText}
            </div>
            <div style={{ display: 'none', fontFamily: 'PingFangSC-Regular, PingFang SC' }} ref={zhRef}>
              {zhText}
            </div>
          </RobotContent>
          {
            isRetain && (
              <ColumnCenter style={{ alignItems: 'flex-start' }}>
                <img src={greenCheck} style={{ width: 16, height: 15, paddingLeft: 15 }} />
              </ColumnCenter>
            )
          }
        </Row>
      </ColumnCenter>
    </RowLeft>
  );
};

export interface Props {
  loading?: boolean;
  // 流程ID，同一个流程下的loading，只要在流程ID中就不显示这个loading
  flowId?: string;
  zhText?: any;
  enText?: any;
  style?: CSSProperties;
}

export default CheckLoading;
